import type { PublicProfile } from '../../services/publicProfileService'
import type { ChecklistMemberOption } from '../../types/schema'
import { parseWorkspaceRole } from '../../utils/workspacePermissions'

export const normalizeChecklistMemberRole = (role: unknown): ChecklistMemberOption['role'] =>
  parseWorkspaceRole(role) ?? 'VIEWER'

export const resolveChecklistMemberDisplayName = (
  membershipData: Record<string, unknown>,
  profile: PublicProfile | Record<string, unknown> | undefined | null,
  fallback: string,
): string => {
  if (profile && typeof profile === 'object') {
    const preferences = (profile as Record<string, unknown>).displayPreferences
    if (preferences && typeof preferences === 'object') {
      const computedName = (preferences as { computedName?: unknown }).computedName
      if (typeof computedName === 'string' && computedName.trim()) return computedName.trim()
    }
  }
  const directCandidates = [
    profile?.displayName,
    membershipData.displayName,
    membershipData.name,
    profile?.username,
    membershipData.phone,
    fallback,
  ]
  for (const candidate of directCandidates) {
    if (typeof candidate === 'string' && candidate.trim()) return candidate.trim()
  }
  return 'Workspace member'
}
